/* ------------------- IMPORTS */
import styled from '@emotion/styled'
import AssetsCreator from 'api/assetsCreator'
import Utils from 'api/Utils'
import { Box, Icons, Title } from 'components'
import { EmptyState } from 'components/UI'
import SkeletonCard from 'pages/ai-discover/UI/SkeletonCard'
import { useEffect, useState } from 'react'
import { AppStore, T } from 'utils'
import { CrelloProject } from './CrelloProject'

/* ------------------- TYPES  */

/* ------------------- INTERFACES  */
export interface ITemplate {
  description: string
  image: string | null
  measurements: string
  name: string
  templateId: string
}

interface Props {
  onCrelloSave?: (crelloResponse: any) => void
}

export const TemplateSection = ({ onCrelloSave }: Props) => {
  /* ----------------- STATE  */
  const [templates, setTemplates] = useState<ITemplate[]>([])
  const [isLoading, setIsLoading] = useState(true)

  /* ----------------- REF  */

  /* ----------------- ZUSTAND  */

  /* ----------------- VARIABLES  */

  /* ----------------- METHODS  */

  /* ----------------- API CALL  */
  const fetchTemplates = async () => {
    setIsLoading(true)
    try {
      const res = await AssetsCreator.getAllAssetsCreations(AppStore.workspaceId ?? '')

      setTemplates(res[0].associatedTemplates ?? [])
    } catch (e) {
      console.error(e)
    }

    setIsLoading(false)
  }

  /* ----------------- USEEFFECT  */
  useEffect(() => {
    fetchTemplates()
  }, [])

  return (
    <TemplateSectionContainer>
      {/* Loading */}
      {isLoading && (
        <ContainerMyProject>
          <SkeletonCard type={'crelloTemplates'} num={6} key={Utils.generateRandomUIDKey()} />
        </ContainerMyProject>
      )}

      {/* Templates */}
      {!isLoading && templates.length > 0 && (
        <>
          <Title style={{ textAlign: 'center', width: '100%' }}>{T.mediaPage.selectATemplate}</Title>

          <ContainerMyProject>
            {templates.map((template: any) => (
              <CrelloProject isProject={false} key={template._id} template={template} onCrelloSave={onCrelloSave} />
            ))}
          </ContainerMyProject>
        </>
      )}

      {/* Empty state */}
      {!isLoading && templates.length === 0 && (
        <EmptyState
          noPaddingTop
          text={T.error.noTemplates}
          icon={<Icons.sadFace fill={AppStore.theme.o.black} width={72} height={72} />}
          styles={{ width: '403px', height: '257px' }}
        />
      )}
    </TemplateSectionContainer>
  )
}

const TemplateSectionContainer = styled(Box)`
  gap: 16px;
  height: 100%;
`

const ContainerMyProject = styled(Box)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 'auto';
  row-gap: 31px;
  column-gap: 8px;
  overflow-y: scroll;
  height: 90%;
  margin-left: 8px; // compensate for scrollbar
`
